import Icon from '../components/Icon.vue'

Icon.register({
  'grin-beam-sweat': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M456 128C482.5 128 504 107 504 81 504 61 475.5 20.6 462.4 3.2 459.2-1.1 452.8-1.1 449.6 3.2 436.5 20.6 408 61 408 81 408 107 429.5 128 456 128zM456 160C411.9 160 376 124.6 376 81 376 76.6 376.3 66.8 384.1 48.8 345 23.1 298.3 8 248 8 111 8 0 119 0 256S111 504 248 504 496 393 496 256C496 220.9 488.6 187.6 475.5 157.4 469.2 158.9 462.8 160 456 160zM328 152C351.8 152 380.7 181.3 384 223.4 384.7 232 373.2 235.4 369.1 227.9L359.6 210.9C351.9 197.2 340.4 189.3 328.1 189.3S304.3 197.2 296.6 210.9L287.1 227.9C283 235.3 271.5 231.9 272.2 223.4 275.3 181.3 304.2 152 328 152zM168 152C191.8 152 220.7 181.3 224 223.4 224.7 232 213.2 235.4 209.1 227.9L199.6 210.9C191.9 197.2 180.4 189.3 168.1 189.3S144.3 197.2 136.6 210.9L127.1 227.9C122.9 235.3 111.5 231.9 112.2 223.4 115.3 181.3 144.2 152 168 152zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.9 113.5 317.1 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.6 317.1 393.7 327 391.8 338.7 382.5 393.7 308.6 432 248 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-beam-sweat.js
// module id = pofU
// module chunks = 144